import React, { useState } from 'react';
import CustomPhoneInput from './CustomPhoneInput';
import signupImage from '../../assets/headquarters.jpeg';
import marshalLogo from '../../assets/images/marshal-logo.jpeg';
import './Signupmodal.css';

const runtimeApi = (window._env_ && window._env_.REACT_APP_API_URL) || null;
const RAW_API_BASE = runtimeApi || process.env.REACT_APP_API_URL || `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}`;
const API_BASE = RAW_API_BASE.replace(/\/+$/, '').replace(/\/api$/, '');

const HQSignupModal = ({ isOpen, onClose, onSwitchToLogin }) => {
  const [authType, setAuthType] = useState('email');
  const [formData, setFormData] = useState({ fullName: '', email: '', phone: '', password: '', confirmPassword: '', termsAgreed: false });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [otpMethod, setOtpMethod] = useState('whatsapp');
  const [isIndianNumber, setIsIndianNumber] = useState(true);
  const [otpMethodSelected, setOtpMethodSelected] = useState(false); // hides selector once chosen
  const [view, setView] = useState('signup'); // 'signup' or 'verify-otp'
  const [otp, setOtp] = useState('');
  const [resendTimer, setResendTimer] = useState(0);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    let finalValue = value;
    if (name === 'fullName') {
      finalValue = value.replace(/[^a-zA-Z ]/g, '').replace(/\s{2,}/g, ' ').replace(/^\s/, '');
    } else if (name === 'phone') {
      finalValue = value.replace(/[^\d+]/g, '');
      if (value !== finalValue) {
        setErrors(prev => ({ ...prev, phone: 'Only digits are allowed' }));
      } else {
        setErrors(prev => ({ ...prev, phone: '' }));
      }
    }
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : finalValue }));
    if (name !== 'phone' && errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validateForm = () => {
    const newErrors = {};
if (!formData.fullName.trim()) newErrors.fullName = 'Full name is required';
    else if (!/^[a-zA-Z]+( [a-zA-Z]+)*$/.test(formData.fullName)) newErrors.fullName = 'Full name can only contain letters and single spaces';    else if (!/^[a-zA-Z]+(\s?[a-zA-Z]+)*$/.test(formData.fullName)) newErrors.fullName = 'Full name can only contain letters';
    if (authType === 'email') {
      if (!formData.email) newErrors.email = 'Email is required';
      else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Please enter a valid email address';
    } else {
      if (!formData.phone || formData.phone.length <= 1) {
        newErrors.phone = 'Phone number is required';
      } else if (isIndianNumber && formData.phone.length !== 13) {
        newErrors.phone = 'Indian phone numbers must be exactly 10 digits';
      } else if (!/^\+?\d{7,15}$/.test(formData.phone)) {
        newErrors.phone = 'Please enter a valid phone number';
      }
    }
    if (!formData.password) newErrors.password = 'Password is required';
    else if (!formData.password.trim()) newErrors.password = 'Password cannot consist of only spaces';
    else if (formData.password.trim().length < 8) newErrors.password = 'Password must be at least 8 characters';
    else if (!/^\S+$/.test(formData.password)) newErrors.password = 'Password cannot contain spaces';
    if (!formData.confirmPassword) newErrors.confirmPassword = 'Please confirm your password';
    else if (!formData.confirmPassword.trim()) newErrors.confirmPassword = 'Password cannot consist of only spaces';
    else if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = 'Passwords do not match';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  React.useEffect(() => {
    let interval;
    if (view === 'verify-otp' && resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [view, resendTimer]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    
    // Check if phone method is required but missing
    if (authType === 'phone' && isIndianNumber && !otpMethodSelected) {
      setErrors({ general: 'Please select a method to receive the OTP (WhatsApp or SMS).' });
      return;
    }

    if (!formData.termsAgreed) {
      setErrors({ termsAgreed: 'You must agree to the Terms of Service' });
      return;
    }

    setIsLoading(true);
    setErrors({});
    try {
      const response = await fetch(`${API_BASE}/api/auth/admin-users/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: authType === 'email' ? formData.email : undefined,
          phone: authType === 'phone' ? formData.phone : undefined,
          password: formData.password,
          fullName: formData.fullName,
          phoneAuthMethod: authType === 'phone' ? otpMethod : undefined,
        })
      });
      const data = await response.json();
      if (response.ok && data.success) {
        setView('verify-otp');
      } else {
        setErrors({ general: data.error || 'Failed to register account' });
      }
    } catch (err) {
      setErrors({ general: 'Connection failed. Please try again.' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (resendTimer > 0 || isLoading) return;
    
    setErrors({});
    setIsLoading(true);
    
    try {
      const response = await fetch(`${API_BASE}/api/auth/admin-users/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: authType === 'email' ? formData.email : undefined,
          phone: authType === 'phone' ? formData.phone : undefined,
          password: formData.password,
          fullName: formData.fullName,
          phoneAuthMethod: authType === 'phone' ? otpMethod : undefined,
        })
      });

      const data = await response.json();
      
      if (response.ok) {
        setResendTimer(45);
        setOtp('');
      } else {
        setErrors({ general: data.error || 'Failed to resend OTP. Please try again.' });
      }
    } catch (error) {
      setErrors({ general: 'Network error. Please try again.' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    if (!otp) {
      setErrors({ general: 'OTP is required' });
      return;
    }

    setIsLoading(true);
    setErrors({});
    try {
      const identifier = authType === 'email' ? formData.email : formData.phone;
      const response = await fetch(`${API_BASE}/api/auth/verify-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          identifier,
          authType,
          otp
        })
      });
      const data = await response.json();
      if (response.ok && data.success) {
        // Automatically switch them to login view
        onSwitchToLogin();
      } else {
        setErrors({ general: data.error || 'Invalid OTP. Please try again.' });
      }
    } catch (err) {
      setErrors({ general: 'Connection failed. Please try again.' });
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="signup-modal-overlay" onClick={onClose}>
      <div className="signup-modal-container auth-modal" onClick={e => e.stopPropagation()} style={{ '--modal-bg-image': `url(${signupImage})` }}>
        <button className="modal-close-btn" onClick={onClose} aria-label="Close">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
        <div className="modal-form-section">
          <div className="form-content">
            <div className="auth-modal-header text-center" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
              <div className="modal-logo" style={{ marginBottom: '0', width: '100%', display: 'flex', justifyContent: 'center' }}>
                <img src={marshalLogo} alt="Logo" className="modal-logo-image" style={{ width: '80px', maxWidth: '100%', height: 'auto', objectFit: 'contain', display: 'block', margin: '0 auto' }} />
              </div>
              <hr style={{ border: 'none', borderTop: '2px solid #e0e0e0', margin: '15px 0', width: '100%' }} />
              <h2 style={{ marginTop: '0', marginBottom: '15px', fontSize: '22px', fontWeight: '600', width: '100%', textAlign: 'center' }}>HQ Portal</h2>
            </div>
            <div className="auth-toggle">
              <button className="toggle-btn active">HQ Sign Up</button>
              <button className="toggle-btn" onClick={onSwitchToLogin}>HQ Log In</button>
            </div>
            <div className="form-main">
              <h2 className="form-title">{view === 'signup' ? 'Create HQ Account' : 'Verify Your Account'}</h2>
              <p className="form-subtitle">{view === 'signup' ? 'Join the HQ team today' : `Enter the OTP sent to your ${authType}`}</p>
              {errors.general && <div className="error-message">{errors.general}</div>}
              
              {view === 'signup' ? (
                <form onSubmit={handleSubmit} className="signup-form">
                  <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '2px solid #e0e0e0', paddingBottom: '10px' }}>
                    <button type="button" onClick={() => { setAuthType('email'); setFormData(prev => ({ ...prev, phone: '' })); setErrors(prev => ({ ...prev, phone: '' })); }} style={{ flex: 1, padding: '10px', border: 'none', background: authType === 'email' ? '#7c3aed' : '#f3f4f6', color: authType === 'email' ? 'white' : '#6b7280', borderRadius: '6px', cursor: 'pointer', fontWeight: '500' }}>Email</button>
                    <button type="button" onClick={() => { setAuthType('phone'); setFormData(prev => ({ ...prev, email: '' })); setErrors(prev => ({ ...prev, email: '' })); }} style={{ flex: 1, padding: '10px', border: 'none', background: authType === 'phone' ? '#7c3aed' : '#f3f4f6', color: authType === 'phone' ? 'white' : '#6b7280', borderRadius: '6px', cursor: 'pointer', fontWeight: '500' }}>Phone</button>
                  </div>
                  <div className="modal-form-group-full-width">
                    <input type="text" id="hq-fullName" name="fullName" placeholder=" " value={formData.fullName} onChange={handleInputChange} disabled={isLoading} />
                    <label htmlFor="hq-fullName">Full Name</label>
                    {errors.fullName && <span className="field-error">{errors.fullName}</span>}
                  </div>
                  {authType === 'email' ? (
                    <div className="modal-form-group">
                      <input type="email" id="hq-signup-email" name="email" placeholder=" " value={formData.email} onChange={handleInputChange} disabled={isLoading} required />
                      <label htmlFor="hq-signup-email">Email{' '}*</label>
                      {errors.email && <span className="field-error">{errors.email}</span>}
                    </div>
                  ) : (
                    <>
                      <div className="phone-input-wrapper" style={{ marginBottom: '28px' }}>
                        <span className="phone-input-label">Phone Number *</span>
                        <CustomPhoneInput
                          id="hq-signup-phone"
                          defaultCountry="in"
                          onChange={(raw, countryData) => {
                            setFormData(prev => ({ ...prev, phone: '+' + raw }));
                            if (errors.phone) setErrors(prev => ({ ...prev, phone: '' }));
                            setOtpMethodSelected(false);
                            if (countryData && countryData.dialCode === '91') {
                              setIsIndianNumber(true);
                            } else {
                              setIsIndianNumber(false);
                              setOtpMethod('whatsapp');
                            }
                          }}
                          disabled={isLoading}
                        />
                        {errors.phone && <span className="field-error" style={{ fontSize: '12px', color: '#ef4444', marginTop: '4px', display: 'block' }}>{errors.phone}</span>}
                      </div>
                      
                      {isIndianNumber && formData.phone && formData.phone.length > 2 && !otpMethodSelected && (
                        <div className="otp-method-selector" style={{ marginBottom: '20px', background: '#f9fafb', padding: '12px 16px', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
                          <label style={{ display: 'block', marginBottom: '10px', fontSize: '14px', color: '#374151', fontWeight: '600' }}>Send verification code via:</label>
                          <div style={{ display: 'flex', gap: '20px' }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', color: '#4b5563' }}>
                              <input 
                                type="radio" 
                                name="otpMethod"
                                value="whatsapp" 
                                checked={otpMethod === 'whatsapp'} 
                                onChange={() => { setOtpMethod('whatsapp'); setOtpMethodSelected(true); }} 
                                style={{ accentColor: '#7c3aed', width: '16px', height: '16px' }}
                              /> 
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="#25D366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/></svg> WhatsApp
                            </label>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', color: '#4b5563' }}>
                              <input 
                                type="radio" 
                                name="otpMethod"
                                value="sms" 
                                checked={otpMethod === 'sms'} 
                                onChange={() => { setOtpMethod('sms'); setOtpMethodSelected(true); }} 
                                style={{ accentColor: '#7c3aed', width: '16px', height: '16px' }}
                              /> 
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg> SMS
                            </label>
                          </div>
                        </div>
                      )}
                      {isIndianNumber && formData.phone && formData.phone.length > 2 && otpMethodSelected && (
                        <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 14px', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '8px', fontSize: '13px', color: '#16a34a' }}>
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                          OTP via <strong style={{ marginLeft: '3px' }}>{otpMethod === 'whatsapp' ? 'WhatsApp' : 'SMS'}</strong>
                          <button
                            type="button"
                            onClick={() => setOtpMethodSelected(false)}
                            style={{ marginLeft: 'auto', background: 'none', border: 'none', color: '#16a34a', cursor: 'pointer', fontSize: '12px', textDecoration: 'underline', padding: 0 }}
                          >Change</button>
                        </div>
                      )}
                    </>
                  )}
                  <div className="modal-form-group">
                    <div className="password-input-wrapper">
                      <input type={showPassword ? 'text' : 'password'} id="hq-signup-password" name="password" placeholder=" " value={formData.password} onChange={handleInputChange} disabled={isLoading} />
                      <label htmlFor="hq-signup-password">Password</label>
                      <button type="button" className="password-toggle" onClick={() => setShowPassword(!showPassword)} disabled={isLoading}>
                        {showPassword ? (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                        ) : (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>)}
                      </button>
                    </div>
                    {errors.password && <span className="field-error">{errors.password}</span>}
                  </div>
                  <div className="modal-form-group">
                    <div className="password-input-wrapper">
                      <input type={showConfirmPassword ? 'text' : 'password'} id="hq-confirmPassword" name="confirmPassword" placeholder=" " value={formData.confirmPassword} onChange={handleInputChange} disabled={isLoading} />
                      <label htmlFor="hq-confirmPassword">Confirm Password</label>
                      <button type="button" className="password-toggle" onClick={() => setShowConfirmPassword(!showConfirmPassword)} disabled={isLoading}>
                        {showConfirmPassword ? (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                        ) : (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>)}
                      </button>
                    </div>
                    {errors.confirmPassword && <span className="field-error">{errors.confirmPassword}</span>}
                  </div>
                  <div className="form-options">
                    <div className="user-signup-terms-container">
                      <input type="checkbox" id="hq-terms" name="termsAgreed" className="auth-custom-checkbox" checked={formData.termsAgreed} onChange={handleInputChange} disabled={isLoading} />
                      <label htmlFor="hq-terms" className="user-signup-terms-label">I agree to the Terms of Service and Privacy Policy</label>
                    </div>
                  </div>
                  <button type="submit" className="submit-btn" disabled={isLoading}>{isLoading ? 'Creating Account...' : 'Create HQ Account'}</button>
                </form>
              ) : (
                <form onSubmit={handleVerifyOtp} className="signup-form">
                  <div className="modal-form-group">
                    <input type="text" id="hq-otp" name="otp" placeholder=" " value={otp} onChange={(e) => { setOtp(e.target.value); if (errors.general) setErrors({}); }} disabled={isLoading} autoFocus />
                    <label htmlFor="hq-otp">Verification Code (OTP)</label>
                  </div>
                  <button type="submit" className="submit-btn" disabled={isLoading}>{isLoading ? 'Verifying...' : 'Verify OTP & Finish Signup'}</button>
                  <div style={{ textAlign: 'center', marginTop: '15px' }}>
                    <button type="button" onClick={handleResendOtp} disabled={resendTimer > 0 || isLoading} style={{ background: 'transparent', color: resendTimer > 0 ? '#9ca3af' : '#7c3aed', border: 'none', cursor: resendTimer > 0 ? 'not-allowed' : 'pointer', fontWeight: '500', fontSize: '14px', marginBottom: '10px' }}>
                      {resendTimer > 0 ? `Resend OTP in ${resendTimer}s` : 'Resend OTP'}
                    </button>
                  </div>
                  <div style={{ textAlign: 'center', marginTop: '5px' }}>
                    <button type="button" onClick={() => setView('signup')} style={{ background: 'transparent', color: '#6b7280', border: 'none', cursor: 'pointer', textDecoration: 'underline', fontSize: '14px' }}>Back</button>
                  </div>
                </form>
              )}
              
              {view === 'signup' && (
                <div className="form-footer">
                  <p>Already have an account? <button type="button" onClick={onSwitchToLogin} className="link-btn">HQ Sign In</button></p>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="modal-image-section">
          <img src={signupImage} alt="HQ Signup" className="modal-image" />
          <div className="image-overlay">
            <div className="decorative-shape top-left-shape"></div>
            <div className="decorative-shape bottom-right-shape"></div>
            <div className="overlay-content">
              <div className="overlay-card">
                <h3>HQ Access</h3>
                <p>Manage clients, view platform analytics, and oversee operations.</p>
              </div>
              <div className="bottom-overlay">
                <h3>Platform Management, Simplified.</h3>
                <p>Get started with the HQ Dashboard today!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HQSignupModal;
